import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {UserPasswordForm} from '../../../Models/User/user-password.model';
import {UserPinForm} from '../../../Models/User/user-pin.model';
import {UserDataForm} from '../../../Models/User/user-data.model';
import {UsersModelService} from '../../Models/Users/users-model.service';
import {UserStoreForm} from '../../../Models/User/user-store.model';

@Injectable({
  providedIn: 'root'
})
export class UsersApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: UsersModelService,
  ) {
    super(injector);
  }

  /**
   * Obtener usuarios
   *
   */
  public getUsers(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      this.httpCall('getUsuarios', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener detalle de un usuario
   * 
   */
  public getUserDetail(id: number): Promise<ApiResponse> {
    return new Promise((resolve, reject) => {

      this.httpCall(`hhrr/users/${id}`, {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Guardar usuario
   *
   */
  public setUser(params: UserStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? 'hr/users/' + params.id : 'hr/users';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params.asFormData()).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Cambiar foto del usuario de la sesión
   *
   */
  public setUserPhoto(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      this.httpCall('postImagenPerfil', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Cambiar contraseña del usuario de la sesión
   *
   */
  public changePassword(params: UserPasswordForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      this.httpCall('postPassword', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Cambiar pin del usuario de la sesión
   *
   */
  public changePin(params: UserPinForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      this.httpCall('postPin', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Actualizar los datos del usuario de la sesión
   *
   */
  public setUserSession(params: UserDataForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      this.httpCall('postUser', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Activar/Desactivar un usuario
   *
   */
  toggleUser(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('toggleActivoUsuario', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar un usuario
   *
   */
  deleteUser(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteUsuario', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

}
